import { Tab, Tabs } from '@mui/material';
import { AppConfig } from 'AppConfig';
import { fetchData } from 'features/user/userActions';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, Outlet, useLocation } from 'react-router-dom';
import routePaths from 'routes/routePaths';
import { tabNoUnderlineSx, tabsNoUnderlineSx } from 'common/tabSx';
import { store } from 'store/store';

const WhiteLabelNavigator = () => {
  const WHITE_LABEL_URL = routePaths.whiteLabeling;
  const TAG_MANAGEMENT_URL = `${WHITE_LABEL_URL}/${AppConfig.WHITE_LABEL_SUB_URL.TAG_MANAGEMENT}`;
  const VENDOR_MANAGEMENT_URL = `${WHITE_LABEL_URL}/${AppConfig.WHITE_LABEL_SUB_URL.VENDOR_LABELING}`;
  const VENDOR_MANAGEMENT_BROKER_VIEW_URL = `${WHITE_LABEL_URL}/${AppConfig.WHITE_LABEL_SUB_URL.VENDOR_LABELING_BROKER_VIEW}`;
  const WHITE_LABEL_MANAGEMENT_URL = `${WHITE_LABEL_URL}/${AppConfig.WHITE_LABEL_SUB_URL.WHITE_LABEL}`;
  const WHITE_LABEL_BROKER_URL = `${WHITE_LABEL_URL}/${AppConfig.WHITE_LABEL_SUB_URL.WHITE_LABEL_BROKER}`;

  const location = useLocation();
  const { defaultUserState, currentTenantCd } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (defaultUserState) {
        store.dispatch(fetchData(currentTenantCd, AppConfig.APP_CODE_FO, { explicitTenant: false }));
      }
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        sx={tabsNoUnderlineSx}>
        <Tab
          label="White Label"
          value={WHITE_LABEL_MANAGEMENT_URL}
          component={Link}
          to={WHITE_LABEL_MANAGEMENT_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="White Label: Broker"
          value={WHITE_LABEL_BROKER_URL}
          component={Link}
          to={WHITE_LABEL_BROKER_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="Vendor Labeling: Company"
          value={VENDOR_MANAGEMENT_URL}
          component={Link}
          to={VENDOR_MANAGEMENT_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="Vendor Labeling: Broker"
          value={VENDOR_MANAGEMENT_BROKER_VIEW_URL}
          component={Link}
          to={VENDOR_MANAGEMENT_BROKER_VIEW_URL}
          sx={tabNoUnderlineSx}
        />
        <Tab
          label="Tag Management"
          value={TAG_MANAGEMENT_URL}
          component={Link}
          to={TAG_MANAGEMENT_URL}
          sx={tabNoUnderlineSx}
        />
      </Tabs>
      <Outlet />
    </>
  );
};

export default WhiteLabelNavigator;
